module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container table-data"
  }, [_c('a', {
    staticStyle: {
      "display": "none !important"
    },
    attrs: {
      "id": "downLoad",
      "href": _vm.downloadUrl,
      "download": _vm.downloadName
    }
  }), _vm._v(" "), _c('el-form', {
    ref: "queryForm",
    attrs: {
      "size": "mini",
      "inline": true,
      "label-position": "left",
      "label-width": _vm.queryFormLabelWidth,
      "model": _vm.addQuery
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "报表名称：",
      "prop": "type"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "全部"
    },
    model: {
      value: (_vm.addQuery.name),
      callback: function($$v) {
        _vm.$set(_vm.addQuery, "name", $$v)
      },
      expression: "addQuery.name"
    }
  }, _vm._l((_vm.nameList), function(item) {
    return _c('el-option', {
      key: item.idx,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "日期：",
      "prop": "date",
      "label-width": "80px"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "placeholder": "请选择日期"
    },
    model: {
      value: (_vm.addQuery.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.addQuery, "dateRange", $$v)
      },
      expression: "addQuery.dateRange"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addItem
    }
  }, [_vm._v("生成报表")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": _vm.refresh
    }
  }, [_vm._v("重置")])], 1)], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px",
      "padding-bottom": "16px",
      "padding-top": "20px"
    }
  }, [_vm._v("提示：报表生成需要一点时间，手动刷新网页查看报表最新状态")]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "编号",
      "type": "index",
      "index": _vm.indexMethod
    }
  }), _vm._v(" "), _vm._l((_vm.tableColumn), function(item, index) {
    return _c('el-table-column', {
      key: index,
      attrs: {
        "prop": item.id,
        "label": item.name,
        "show-overflow-tooltip": true,
        "width": item.width
      }
    })
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.status) ? _c('span', {
          staticStyle: {
            "color": "#ff9900"
          }
        }, [_vm._v("查询中")]) : _c('span', [_vm._v("已完成")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status) ? _c('el-button', {
          staticClass: "tab-btn",
          attrs: {
            "size": "mini",
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.downloadItem(scope.row)
            }
          }
        }, [_vm._v("下载报表")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          },
          nativeOn: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.deleteItem(scope.row)
            }
          }
        }, [_vm._v("\n            删除\n          ")])]
      }
    }])
  })], 2), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.queryForm.pageNo,
      "page-sizes": _vm.pageSizes,
      "page-size": _vm.queryForm.pageSize,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3feabcd6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/views/report/school.vue
// module id = 906
// module chunks = 0